import React, { Component } from "react";
import { Collapse, ListGroup, Spinner } from "react-bootstrap";
import { history } from "../../_helpers/history";

import axiosInstance from "../../_helpers/axiosConfig";
import Countdown from "../Utility/Countdown";
import MoreInfo from "../Reservation/MoreInfo";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FadeIn from "react-fade-in";
import moment from "moment-timezone";

import "./style.css";

export default class AcceptAppointmentPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: null,
      canMakeAppt: null,
      showMoreInfo: false,
      shouldCancel: null,
      shouldWaitlist: null,
    };
  }

  cancelMessage = () => {
    return (
      <div>
        Due to the high demand and limited nature of the COVID-19 vaccine we can
        only schedule people on a first come first serve basis.&nbsp;
        <b>
          We will <i>NOT</i> keep you on the waitlist and you will not be
          contacted further regarding any appointment times.
        </b>
      </div>
    );
  };

  waitlistMessage = () => {
    return (
      <div>
        Due to the high demand and limited nature of the COVID-19 vaccine we can
        only schedule people on a first come first serve basis.&nbsp;
        <b>
          We will keep you on the waitlist and contact you as soon as possible
          with another available time slot.
        </b>
      </div>
    );
  };

  handleFooterStyle = () => {
    if (this.state.shouldCancel || this.state.shouldWaitlist) {
      return "make-relative";
    } else return "make-fixed";
  };

  handleSubmitText = () => {
    if (this.state.submitting) {
      return (
        <span>
          <Spinner animation="border" size="sm" /> Submitting...
        </span>
      );
    } else if (this.state.canMakeAppt) {
      return "Confirm Appointment";
    } else if (this.state.shouldCancel) {
      return "Cancel Appointment";
    } else if (this.state.shouldWaitlist) {
      return "Waitlist Me";
    }
  };

  handleSubmitApptDecision = () => {
    this.setState({ submitting: true }, () => {
      let decision = {};
      let redirect = "";

      if (this.state.canMakeAppt) {
        decision = { action: "accept" };
        redirect = `/appointment/${this.props.token}`;
      } else if (this.state.shouldCancel) {
        decision = { action: "reject", reject: "remove" };
        redirect = "cancelled";
      } else if (this.state.shouldWaitlist) {
        decision = { action: "reject", reject: "keep" };
        redirect = "waitlisted";
      }

      axiosInstance
        .request({
          method: "POST",
          url: `/vaccine/appointment/` + this.props.token,
          data: decision,
        })
        .then((response) => {
          if (this.state.canMakeAppt) {
            window.location.reload();
          } else {
            history.push(redirect);
          }
        })
        .catch((error) => {
          this.setState({ submitting: false }, () => {
            alert(
              "Something went wrong. Please check your internet and try again."
            );
          });
        });
    });
  };

  render() {
    return (
      <div>
        <Header />
        <FadeIn>
          <div className="row accept-container h-100 w-100">
            <div className="col">
              <div className="card shadow px-3 mb-5 px-sm-5 py-5">
                <div className="time-title text-center">
                  <h2 className="text-capitalize">{this.props.name}</h2>
                  <h2 className="card-title pt-3">
                    Our next available appointment is:
                  </h2>
                  { this.props.vaccine === 'janssen' && 
                    this.props.secondAppt === null  
                  ?
                  <h4 className="py-2">
                   {moment
                     .tz(this.props.date, this.props.timezone)
                     .local()
                     .format("dddd MMMM Do, YYYY [at] hh:mm A")}
                  </h4>
                  :
                  <>
                    <h4 className="py-2">
                      First Dose:{" "}
                      {moment
                        .tz(this.props.date, this.props.timezone)
                        .local()
                        .format("dddd MMMM Do, YYYY [at] hh:mm A")}
                    </h4>
                    <h4 className="py-2">
                      Second Dose:{" "}
                      {moment
                        .tz(
                          this.props.secondAppt.date,
                          this.props.secondAppt.timezone
                        )
                        .local()
                        .format("dddd MMMM Do, YYYY [at] hh:mm A")}
                    </h4>
                    <h5 className="text-muted">
                      The COVID-19 vaccine requires two doses.
                    </h5>
                  </>
                  }
                </div>
                <hr />
                <label className="text-center">
                  <span className="text-danger">*</span> Would you like to
                  accept this appointment?
                </label>
                <ListGroup horizontal className="text-center mx-4">
                  <ListGroup.Item
                    action
                    href="#yes"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        canMakeAppt: true,
                        showMoreInfo: false,
                        shouldCancel: null,
                        shouldWaitlist: null,
                      });
                    }}
                  >
                    <b>Yes</b>
                  </ListGroup.Item>
                  <ListGroup.Item
                    action
                    href="#no"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        canMakeAppt: false,
                        showMoreInfo: true,
                      });
                    }}
                  >
                    <b>No</b>
                  </ListGroup.Item>
                </ListGroup>

                <Countdown
                  sentAt={this.props.sentAtDate}
                  timezone={this.props.sentAtTimezone}
                />

                <Collapse in={this.state.showMoreInfo}>
                  <div className="more-info px-sm-4 pt-4 ">
                    <hr />
                    <b>
                      I{" "}
                      <u>
                        <i>CAN NOT</i>
                      </u>{" "}
                      make this appointment. <br /> Please select an option:
                    </b>
                    <br />
                    <ListGroup className="py-3">
                      <div className="row border border-bottom-0">
                        <MoreInfo
                          showOn={["hover", "focus"]}
                          message={this.waitlistMessage()}
                        >
                          <a href="/" onClick={(e) => e.preventDefault()}>
                            <div className="col-auto more-info-popover h-100">
                              <div>
                                more&nbsp;
                                <br className="d-sm-none" />
                                info
                              </div>
                            </div>
                          </a>
                        </MoreInfo>
                        <div className="col px-0">
                          <ListGroup.Item
                            action
                            className={
                              this.state.shouldWaitlist
                                ? "active shouldWaitlist"
                                : "shouldWaitlist"
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({
                                shouldCancel: false,
                                shouldWaitlist: true,
                              });
                            }}
                          >
                            Keep me on the waitlist and contact me with another
                            appointment time.
                          </ListGroup.Item>
                        </div>
                      </div>
                      <div className="row border">
                        <MoreInfo
                          showOn={["hover", "focus"]}
                          message={this.cancelMessage()}
                        >
                          <a href="/" onClick={(e) => e.preventDefault()}>
                            <div className="col-auto more-info-popover h-100">
                              <div>
                                more&nbsp;
                                <br className="d-sm-none" />
                                info
                              </div>
                            </div>
                          </a>
                        </MoreInfo>
                        <div className="col px-0">
                          <ListGroup.Item
                            action
                            className={
                              this.state.shouldCancel
                                ? "active shouldCancel"
                                : "shouldCancel"
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({
                                shouldCancel: true,
                                shouldWaitlist: false,
                              });
                            }}
                          >
                            Remove me from the waitlist indefinitely.
                          </ListGroup.Item>
                        </div>
                      </div>
                    </ListGroup>
                  </div>
                </Collapse>

                <div
                  className={
                    this.state.canMakeAppt ||
                      this.state.shouldCancel ||
                      (!this.state.canMakeAppt && this.state.shouldWaitlist)
                      ? "d-block mx-4"
                      : "d-none"
                  }
                >
                  <button
                    onClick={this.handleSubmitApptDecision}
                    disabled={this.state.submitting}
                    className="btn btn-primary btn-lg btn-block mt-4"
                  >
                    {this.handleSubmitText()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
        <Footer footerStyle={this.handleFooterStyle()} />
      </div>
    );
  }
}
